/* eslint-disable camelcase */
// Libraries
import {
    Table,
    TableFilter,
    RoleViewEditForm,
    CreateRoleForm,
    BreadCrumb,
    Popup,
    RoleMakerView,
} from '../../components';
import { getRoleStatusOptions } from '../../utils/helperMethods';
import {
    fetchRolesRequest,
    getMakersDetailsRequest,
    getAllResourcePermissionsRequest,
} from './redux/roleManagement.actions';
import PendingVerification from './PendingVerification';
import React, { useMemo, useState, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { useHistory, Switch, Route } from 'react-router-dom';

// Layouts

// Components

// Actions

// Styles
import './roleManagement.scss';

const resourceDetailToFormData = data => {
    if (data && data.resourceDetail) {
        let result = { subPermissions: {} };

        data.resourceDetail.forEach(item => {
            result[item.resourceName] = item.permissionDetail.map(
                permission => permission.permissionId
            );

            item.permissionDetail.forEach(permission => {
                if (permission.subPermissionDetails) {
                    result['subPermissions'][
                        permission.permissionName
                    ] = permission.subPermissionDetails.map(
                        permission => permission.permissionId
                    );
                }
            });
        });

        result.roleName = data.roleName;
        result.roleStatus = data?.roleStatus?.toUpperCase();

        return result;
    }

    return {};
};

const filterFieldList = [
    {
        fieldType: 'date',
        label: 'Date Range',
        name: 'createdOn',
        props: {},
    },
    {
        fieldType: 'input',
        label: 'Created By',
        name: 'createdBy',
        props: {
            placeholder: 'Enter Name',
        },
    },
    {
        fieldType: 'radio',
        label: 'Status',
        name: 'status',
        props: {
            options: getRoleStatusOptions(),
            placeholder: 'Select Status',
            label: 'Select Status',
            labelField: 'label',
            valueField: 'value',
        },
    },
];

const UserActionsRole = ({ data, fetchData, resetPage }) => {
    const [showFilter, setShowFilter] = useState(false);
    const [actionType, setActionType] = useState(null);

    const { original } = data;

    const handleOpenActionPopup = actionType => {
        setShowFilter(true);
        setActionType(actionType);
    };

    const handleCloseOpenActionPopup = () => {
        setShowFilter(false);
        setActionType(null);
    };
    return (
        <div className="userAction  multiItem">
            <button
                className="edit"
                onClick={() => handleOpenActionPopup('edit')}
            />
            <button
                className="view"
                onClick={() => handleOpenActionPopup('view')}
            />
            <Popup
                title={original.roleName}
                actionType={actionType}
                showCloseIcon
                showOverlay
                showFilter={showFilter}
                data={original}
                closePopup={handleCloseOpenActionPopup}
            >
                <CreateRoleForm
                    actionType={actionType}
                    roleData={original}
                    initialValues={resourceDetailToFormData(original)}
                    fetchData={fetchData}
                    resetPage={resetPage}
                    handleOpenActionPopup={handleOpenActionPopup}
                    closePopup={handleCloseOpenActionPopup}
                />
            </Popup>
        </div>
    );
};

const RoleManagementActionsMaker = ({ data, fetchData, resetPage }) => {
    const [showFilter, setShowFilter] = useState(false);
    const [actionType, setActionType] = useState(null);

    const { original } = data;
    const handleOpenActionPopup = actionType => {
        setShowFilter(true);
        setActionType(actionType);
    };

    const handleCloseOpenActionPopup = isFetch => {
        setShowFilter(false);
        setActionType(null);
        if (isFetch && !isFetch.target) {
            fetchData({
                pageIndex: 1,
                pageSize: 10,
                status: 'UNDER_APPROVAL',
            });
            resetPage();
        }
    };
    return (
        <div className="userAction multiItem">
            <button
                className="view"
                onClick={() => handleOpenActionPopup('view')}
            />
            <Popup
                title={original.roleName}
                actionType={actionType}
                showCloseIcon
                showOverlay
                showFilter={showFilter}
                data={original}
                closePopup={handleCloseOpenActionPopup}
            >
                <CreateRoleForm
                    actionType={actionType}
                    roleData={original}
                    initialValues={resourceDetailToFormData(
                        original.resourceDetail
                    )}
                    handleOpenActionPopup={handleOpenActionPopup}
                    closePopup={handleCloseOpenActionPopup}
                />
            </Popup>
        </div>
    );
};

const RoleManagement = props => {
    const {
        roleManagementData,
        actions,
        loader: { showLoader },
    } = props;

    const {
        error,
        tableData,
        makerData,
        makerPagination,
        isLoading,
        pagination,
        allResourcePermissionDetails,
    } = roleManagementData;

    const history = useHistory();

    useEffect(() => {
        if (
            !allResourcePermissionDetails ||
            allResourcePermissionDetails.length === 0
        ) {
            actions.getAllResourcePermissionsRequest();
        }
    }, [actions, allResourcePermissionDetails]);

    const [showFilter, setShowFilter] = useState(false);
    const [filterData, setFilterData] = useState({});

    const handleCreateRole = () => {
        setShowFilter(true);
    };

    const handleCloseCreateRole = () => {
        setShowFilter(false);
    };

    const columns = useMemo(
        () => [
            { header: 'Role Name', accessor: 'roleName' },
            { header: 'Created Date', accessor: 'roleCreationDate' },
            { header: 'Created By', accessor: 'roleCreatedByName' },
            { header: 'Status', accessor: 'roleStatus' },
            { header: 'Action', accessor: 'action' },
        ],
        []
    );

    const pendingColumns = useMemo(
        () => [
            { header: 'Role Name', accessor: 'roleName' },
            { header: 'Date', accessor: 'roleCreatedDate' },
            {
                header: 'Request User',
                accessor: 'roleCreatedUpdatedName',
            },
            { header: 'Request Type', accessor: 'lastActions' },
            { header: 'Action', accessor: 'action' },
        ],
        []
    );

    const handleBackClick = () => {
        history.push('/rolemanagement');
    };

    const pageSizeOptions = [10, 20, 40, 60];

    // We'll start our table without any data
    const [pageCount, setPageCount] = useState(0);
    const [roleStatus, setRoleStatus] = useState('');
    const [isResetPage, setIsResetPage] = useState(false);
    const [pageSize, setPageSize] = useState(10);
    const [pageSizeMaker, setPageSizeMaker] = useState(10);
    const [pageCountMaker, setPageCountMaker] = useState(0);

    const fetchData = useCallback(
        ({ pageSize, pageIndex, roleStatus }) => {
            // This will get called when the table needs new data
            // You could fetch your data from literally anywhere,

            const data = {
                pageSize,
                pageIndex,
                roleStatus,
                sort: 'roleCreationDate',
            };
            actions.fetchRolesRequest({ ...data, ...filterData });
            setPageSize(pageSize);
        },
        [actions, filterData]
    );

    const fetchDataMaker = useCallback(
        ({ pageSize, pageIndex, roleStatus }) => {
            // This will get called when the table needs new data
            // You could fetch your data from literally anywhere,

            const request = {
                resultPerPage: pageSize,
                page: pageIndex,
                status: 'UNDER_APPROVAL',
            };
            actions.getMakersDetailsRequest(request);
            setPageSizeMaker(pageSize);
        },
        [actions]
    );

    useEffect(() => {
        setPageCount(Math.ceil(pagination.totalNumberOfRecords / pageSize));
    }, [pageSize, pagination.totalNumberOfRecords]);

    useEffect(() => {
        if (makerPagination) {
            setPageCountMaker(
                Math.ceil(makerPagination.totalNumberOfRecords / pageSizeMaker)
            );
        } else {
            setPageCountMaker(0);
        }
    }, [makerPagination, makerPagination.totalNumberOfRecords, pageSizeMaker]);

    return (
        <div className="role-management-wrapper">
            <Switch>
                <Route exact path="/rolemanagement">
                    <Table
                        tableTitle="Role Management"
                        filterActionTitle="Create Role"
                        columns={columns}
                        isFiltersEnable
                        isPaginationEnable
                        data={tableData}
                        filterData={filterData}
                        error={error && error.errorMessage}
                        loading={showLoader || isLoading}
                        roleStatus={roleStatus}
                        pageCount={pageCount}
                        fetchData={fetchData}
                        numberOfRecord={pagination.totalNumberOfRecords}
                        pageSizeOptions={pageSizeOptions}
                        paginationLabel="Rows per page"
                        setRoleStatus={setRoleStatus}
                        onClickTableAction={handleCreateRole}
                        pagePerView={3}
                        isResetPage={isResetPage}
                        afterResetPage={() => setIsResetPage(false)}
                        userActions={data => (
                            <UserActionsRole
                                data={data}
                                fetchData={fetchData}
                                resetPage={() => setIsResetPage(true)}
                            />
                        )}
                        additionalActions={props => (
                            <PendingVerification
                                url="/rolemanagement/pending"
                                {...props}
                            />
                        )}
                        tableFilters={
                            <TableFilter
                                showOverlay
                                fieldsList={filterFieldList}
                                onSubmit={filterValues => {
                                    setFilterData(filterValues);
                                    setIsResetPage(true);
                                }}
                                onReset={resetValue => {
                                    setFilterData(resetValue);
                                    setIsResetPage(true);
                                }}
                            />
                        }
                        tableActionPopup={
                            <Popup
                                title="CREATE ROLE"
                                showCloseIcon
                                showOverlay
                                type="LARGE"
                                showFilter={showFilter}
                                closePopup={handleCloseCreateRole}
                            >
                                <CreateRoleForm
                                    fetchData={fetchData}
                                    initialValues={{ subPermissions: {} }}
                                />
                            </Popup>
                        }
                    />
                </Route>
                <Route exact path="/rolemanagement/pending">
                    <Table
                        tableTitle="Role Management"
                        filterActionTitle=""
                        columns={pendingColumns}
                        isFiltersEnable
                        isPaginationEnable
                        data={makerData}
                        error={error && error.errorMessage}
                        loading={showLoader || isLoading}
                        pageCount={pageCountMaker}
                        fetchData={fetchDataMaker}
                        numberOfRecord={
                            (makerPagination &&
                                makerPagination.totalNumberOfRecords) ||
                            0
                        }
                        pageSizeOptions={pageSizeOptions}
                        paginationLabel="Rows per page"
                        pagePerView={3}
                        isResetPage={isResetPage}
                        afterResetPage={() => setIsResetPage(false)}
                        userActions={data => (
                            <RoleManagementActionsMaker
                                data={data}
                                fetchData={fetchData}
                                resetPage={() => setIsResetPage(true)}
                            />
                        )}
                        tableSubSection={props => (
                            <BreadCrumb
                                {...props}
                                withBack
                                wrapperClass="pendingVerification-section"
                                onBackClick={handleBackClick}
                                title="Pending Verification"
                                breadCrumbs={[
                                    {
                                        name: 'Access Management',
                                        link: '/rolemanagement',
                                    },
                                    {
                                        name: 'Role Management',
                                        link: '',
                                    },
                                ]}
                            />
                        )}
                    />
                </Route>
            </Switch>
        </div>
    );
};

const mapStateToProps = ({ auth, roleManagementData, loader }) => ({
    auth,
    roleManagementData,
    loader,
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(
        {
            getMakersDetailsRequest,
            fetchRolesRequest,
            getAllResourcePermissionsRequest,
        },
        dispatch
    ),
});

RoleManagement.propTypes = {
    actions: PropTypes.object,
    auth: PropTypes.object,
    data: PropTypes.object,
    history: PropTypes.object,
    match: PropTypes.object,
    roleManagementData: PropTypes.object,
    loader: PropTypes.object,
};

UserActionsRole.propTypes = {
    data: PropTypes.object,
    fetchData: PropTypes.object,
    resetPage: PropTypes.func,
};

RoleManagementActionsMaker.propTypes = {
    data: PropTypes.object,
    fetchData: PropTypes.object,
    resetPage: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(RoleManagement);
